import { Locale } from '~app/i18n';
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { transformConfigurationDtoToConfiguration } from '../lib/configuration.mappers';
import { getConfiguration } from '~shared/api/api.service';
import { useLocale } from '~shared/hooks/use-locale';

export const CONFIGURATION_ROOT_QUERY_KEY = ['configuration'] as const;

export const configurationQueryOptions = (locale: Locale = 'en') =>
  queryOptions({
    queryKey: [...CONFIGURATION_ROOT_QUERY_KEY, locale],
    queryFn: ({ signal }) =>
      getConfiguration(locale, { signal }).then(({ data }) =>
        transformConfigurationDtoToConfiguration(data),
      ),
  });

export const useConfiguration = () => {
  const locale = useLocale();

  return useSuspenseQuery(configurationQueryOptions(locale));
};
